import { Box, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useCallback, useState } from 'react';

export function TeamDetailPickRateChip(props: { pickRatePct: number }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const bg = useColorModeValue('blackAlpha.50', 'gray.600');
  const borderColor = useColorModeValue('blackAlpha.100', 'whiteAlpha.300');
  const color = useColorModeValue('gray.700', 'white');

  const closeTooltip = useCallback(() => setTooltipOpen(false), []);
  const openTooltip = useCallback(() => setTooltipOpen(true), []);
  const toggleTooltip = useCallback(() => setTooltipOpen((open) => !open), []);

  const label = props.pickRatePct.toFixed(1);

  return (
    <Tooltip
      label='Selected by'
      hasArrow
      placement='top-start'
      fontSize='sm'
      isOpen={tooltipOpen}
      openDelay={120}
      closeOnClick={false}
      shouldWrapChildren
    >
      <Box
        as='button'
        type='button'
        aria-label={`Selected by ${label}% of players`}
        px={2.5}
        py={0.5}
        borderRadius='md'
        borderWidth='1px'
        borderColor={borderColor}
        bg={bg}
        color={color}
        fontSize='xs'
        fontWeight='semibold'
        lineHeight='short'
        sx={{ fontVariantNumeric: 'tabular-nums' }}
        cursor='help'
        onMouseEnter={openTooltip}
        onMouseLeave={closeTooltip}
        onFocus={openTooltip}
        onBlur={closeTooltip}
        onClick={toggleTooltip}
      >
        {label}%
      </Box>
    </Tooltip>
  );
}
